import React from "react";

import { FormattedMessage } from "react-intl";

import { Button } from "@/components/atoms/Button";
import { Text } from "@/components/atoms/Text";
import { ROUTES } from "~/constants/routes.consts";

import { useCreateSpaceLinkTracking } from "../../_hooks/useCreateSpaceLinkTracking";

import { HeroBanner } from "./HeroBanner";

const HeroSection = () => {
  const linkRef = useCreateSpaceLinkTracking("hero_section");

  return (
    <section className="tw-relative tw-mx-auto tw-overflow-hidden">
      <div className="ps-container-lg-margin ps-container-fixed">
        <div className="tw-h-full tw-relative tw-w-full lg:tw-absolute lg:tw-max-w-[45%] tw-right-0 lg:[-webkit-mask-image:linear-gradient(to_left,white_calc(100%_-_150px),transparent_100%)] lg:[mask-image:linear-gradient(to_left,white_calc(100%_-_150px),transparent_100%)]">
          <HeroBanner />
        </div>
        <div className="ps-row">
          <div className="col-xs-12 tw-flex tw-flex-col tw-gap-16">
            <div className="tw-w-full lg:tw-py-[160px] tw-pb-56 tw-flex tw-flex-col tw-gap-32 lg:tw-max-w-[600px]">
              <Text
                element="h1"
                typeface="headline-6-b"
                className="lg:tw-display-1-b tw-text-gray-900"
              >
                <FormattedMessage defaultMessage="Your space is someone's perfect venue" />
              </Text>
              <Text
                element="p"
                className="tw-text-gray-900 lg:tw-max-w-[520px]"
              >
                <Text
                  className="tw-inline"
                  element="strong"
                  typeface="headline-1-m"
                >
                  <FormattedMessage defaultMessage="Join 50,000+ hosts earning real income on the largest marketplace for venue rentals." />
                </Text>
                &nbsp;
                <Text
                  className="tw-inline"
                  element="span"
                  typeface="body-3-long"
                >
                  <FormattedMessage defaultMessage="We handle payments, protection, and put your space in front of millions of guests." />
                </Text>
              </Text>
              <div>
                <Button
                  appearance="purple"
                  href={ROUTES.CREATE_SPACE}
                  // We're sending analytic event ("host list space clicked") on click of this link.
                  // This ref allows Segment to handle onClick event itself and navigate user only after the tracking request was finsihed.
                  // This prevents user from navigating faster than sending data to Segment.
                  ref={linkRef}
                >
                  <FormattedMessage defaultMessage="List your space for free" />
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export { HeroSection };
